import styled from 'styled-components';

const Row = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  height: 84px;
  padding: 16px 15px;
  border-radius: 12px;
  background-color: ${(props) => props.theme.colors.widget_background};
  
  .overview-skeleton {
    height: 52px;
    width: 200px;
    border-radius: 12px;
    background-color: ${(props) => props.theme.colors.inactive};
    opacity: 0.2;
  }
`;

const DetailsPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  
  .header {
    display: flex;
    flex-direction: column;
    gap: 16px;
    
    .details-row {
      
      .overview-container {
        display: flex;
        
        .button {
          width: 44px;
          height: 44px;
          border-radius: 6px;
          background-color: ${(props) => props.theme.colors.widget_background};
          margin-right: 16px;
        }

        .preview-image {
          width: 44px;
          height: 44px;
          background-color: ${(props) => props.theme.colors.widget_background};
          margin-right: 8px;
        }

        .description {
          display: flex;
          flex-direction: column;
          gap: 6px;

          .title {
            width: 200px;
            height: 20px;
            background-color: ${(props) => props.theme.colors.widget_background};
            border-radius: 6px;
          }
          .overview {
            width: 250px;
            height: 18px;
            background-color: ${(props) => props.theme.colors.widget_background};
            border-radius: 6px;
          }
        }
      }
    }
    
    .tags-row {
      display: flex;
      gap: 8px;
      
      .tag {
        width: 142px;
        height: 26px;
        background-color: ${(props) => props.theme.colors.widget_background};
        border-radius: 6px;
      }
    }

  }
  
  .widgets-container {
    height: 520px;
    background-color: ${(props) => props.theme.colors.widget_background};
    border-radius: 6px;
  }
`;

export default { Row, DetailsPageWrapper };
